import img1 from "../main.images/nfts/nft-1.png";
import img2 from "../main.images/nfts/nft-2.png";
import img3 from "../main.images/nfts/nft-3.png";
import img4 from "../main.images/nfts/nft-4.png";
import img5 from "../main.images/nfts/nft-5.png";
export const nav = [
  {
    name: "Home",
    path: "#home",
  },
  {
    name: "About Us",
    path: "#about",
  },
  {
    name: "Roadmap",
    path: "#roadmap",
  },

  {
    name: "Our Team",
    path: "#team",
  },

  {
    name: "Presale",
    path: "https://presale.golddinar.co.uk",
  },
];
export const Nfts = [img1, img2, img4, img5, img4, img2];
export const team = [
  {
    name: "Lucian Potlog",
    position: "Founder",
    path: img1,
    desc: "A visually talented MF. The man who first drew the concept of these exceptional Shutter Bots along with Artmarketeer. He is an amazing artist who adapted his talents to the digital age by being a professional graphic designer for over 10 years. Even as a young child he would draw on walls, but now he draws inspiration from the walls as he changed profession pursuing photography full time. He is one of Ireland’s best known street photographers with a following of 20k across his channels.",
    link: "https://linktr.ee/lucian.photography",
  },

  {
    name: "Claudiu Potlog",
    position: "Artist",
    path: img2,
    desc: "As a child he must have looked up to his older brother as he followed his footsteps into the life of an artist. Educated in the traditional sense he has a master’s in graphic design. Him and his brother created the art of the NFT collection together probably arguing like brothers do (only because they want the best possible art work) Although he is a master at digital art he still has a huge passion for traditional art with huge canvases across his house that he painted. Most kids played with Lego these two played with pencils.",
    link: "https://linktr.ee/claudesign.art",
  },
  {
    name: "Conor D’Arcy",
    position: "Artist",
    path: img3,
    desc: "Visually unstable but visually passionate. A self-taught filmmaker who loves creating stories. Working freelance for over 3 years making the types of adverts that not all brands can use because they are a little unhinged. He has worked with many start- ups always making sure to be as fun as he is professional. A little bit weird but aren’t we all.",
    link: "https://linktr.ee/codarcfilm",
  },
  {
    name: "Karlo Turić",
    position: "Social Media Manager",
    path: img4,
    desc: "This man makes Joe exotic look like an accountant. A lover of all exotic creatures and an expert in the NFT space. Karlo is an expert in the NFT space and with social media marketing, amassing over 150k across his channels. He is experienced in design, social media and discord management. Running a successful print on demand business for 3 years now. Actively trading and working in the NFT space. Experienced in design, social media and discord management.",
    link: "https://linktr.ee/exotickarlo",
  },
];

export const roadmap = [
  {
    id: "01",
    points: [
      "Website Launch",
      "Marketing Strategy",
      "Social Media Setup",
      "Contract Audit",
      "Pre-Sale Launch",
      "PancakeSwap Launch",
      "Website Re-Design",
    ],
  },
  {
    id: "02",
    points: [
      "Influencer Marketing",
      "Coingecko Listing",
      "Coinmarketcap Listing",
    ],
  },
  {
    id: "03",
    points: [
      "Listing on Bitmart and Whitebit",

      "New Partnerships for major exchange listings",

      "IGD Exchange App",
    ],
    // imgUrl: "/images/nft/9.gif",
  },
  {
    id: "04",
    points: [
      "NFT Collection Sale of 10,000 Items",
      "Large Influencers marketing push Listings on major CEX",
      "Listing on Coinbase",
      "Listing on Binance",
      "Listing on KuCoin",
      "NFT Platform",
      "Donations to Charities",
      "Partnership with local Businesses to implement token in: Dubai, Indonesia, Malaysia, Saudi Arabia.",
    ],
  },
];

export const FAQ = [
  {
    q: "What is NFTs?",
    ans: [
      "NFTs Stands for non-fungible tokens. Non-fungible tokens are unique cryptographic tokens that exist on blockchain and cannot be replicated-having unique identification code, metadata and properties.     ",
    ],
  },

  {
    q: "Why NFTs are so popular?",
    ans: [
      "One of the reasons why NFTs are so popular is explained by what an NFT is. Non-fungible tokens are like a digital receipt that shows that you own a collectable item. NFTs are one of a kind, they can't be exchanged and they reflect ownership of totally unique items. This is where the popularity comes in. ",
    ],
  },
  {
    q: "Are NFTs a good investment? ",
    ans: [
      "NFTs are digital assets that act as secure documentation of ownership and can be a worthwhile investment for collectors and investors. ",
    ],
  },
  {
    q: "What's the future of NFTs?",
    ans: [
      "NFTs have a great future, especially with the idea of turning real world assets into NFTs. Also the idea of fractionalizing NFTs; that is allowing more than one person to co-own an NFT will bring NFT into mass adoption.",
    ],
  },
  {
    q: "How do i know which NFT will be worth of money?",
    ans: [
      "The social proof associated with the project behind an NFT is one of the decisive factors that determine the NFT's value. Checking their profiles on social media platforms like Twitter and Instagram can help one gauge their acceptability.",
    ],
  },
  {
    q: "What about the price?",
    ans: ["The floor price is 0.043 ETH."],
  },
];
